import { MapConfigProps } from './Map.types';

export const defaultMapConfig: MapConfigProps = {
  moveToEntityAnimationDuration: 2.5,
  selectedPolygonZoomLevel: 17,
  showPolygonZoomLevel: 15,
};
